/**
 * 账户信息
 * 作为主要的Demo进行使用
 * PS：本Demo是modules方式的
 */
/**
 * 定义数据
 */
const state = {
  isCollapse: false       // 菜单的展开或收起
}

/**
 * 定义mutations
 * 1. 如果有主动传输数据时候，需要定义这个，和Action配合使用
 * 2. 如果只是简单的双向绑定，不用写了
 */
const mutations = {};

/**
 * 定义getters
 * 可以不用定义，直接使用：this.$store.state.auth.corpsWithNoGroup 方式访问
 */
const getters = {};

/**
 * 定义actions
 * 修改数据是通过：mutations
 * 为什么 修改一个状态actions -> mutations ，而不直接mutations呢？因为：
 * 1. mutations 是同步的，不能异步
 * 2. 在modules下，mutations 无法直接使用
 *
 * 3. Action的写法参考面： return new Promise((resolve, reject) => {}
 * 这样写，可以：
 * store.dispatch('actionA').then(() => {}) 这样了
 */
const actions = {
  /**
   * 登录
   * 1. 存储数据和处理其他数据
   */
  regAuth({commit}, loginInfo) {
    // return new Promise((resolve, reject) => {
    //
    // })
  }
}

/**
 * namespaced 代表启用命名空间，后面调用必须带模块名称了，主要是调用方法时候
 * name:注册的模块名称
 * data：数据
 */
export default {
  name: "uiparam",
  data: {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
  }
}



// WEBPACK FOOTER //
// ./src/store/platform/uiparam.js